module.exports = __webpack_public_path__ + "static/media/galerija_2014 (40).5c28a472.jpg";